import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import "select2";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [ "select" ]

  connect() {
    if (this.selectTarget.dataset.directinit == "true") {
      this.load();
    }
    return 0;
  }

  load()  {
    const select = this.selectTarget;
    if (!(select.dataset.hasOwnProperty('keywords'))) {
      const thisController = this;

      Rails.ajax({
        type: "POST",
        url: select.dataset.url.split("?")[0],
        data: select.dataset.url.split("?")[1],
        success: function (data) {
          const keywords = thisController.formatKeywords(thisController.getKeywords(data))
          $(select).select2({
            data: keywords,
            placeholder: "Votre mot clé ici.",
            maximumSelectionLength: 1,
            theme: 'bootstrap4',
          })
          $(select).on('select2:select', e => e.target.closest("form").submit());
        }
      })

    }   
  }

  formatKeywords(keywords) {
    const all_category_index = keywords.findIndex(category => category.text === "All")
    keywords.forEach((category, index) => {
      if (category.id != 0) {
        keywords[index].children = keywords[index].children.slice(0, 5)
        keywords[index].children.forEach((keyword) => {
          keywords[all_category_index].children = keywords[all_category_index].children.filter((value, index) => {
            return value.id != keyword.id;
       })
        })
      }
      category.children.forEach((keyword, k_index) => {
        keywords[index].children[k_index] = {...keyword, text: `${keyword.text} (${keyword.countValue})`}
      })
    })
    return keywords
  }

  getKeywords(keywords) {
    let id = 1
    const tags = keywords.filter(tag => tag !== null && tag !== undefined)
    if (_.isEmpty(tags)) {
      return null
    }
    const tags_types = new Set(tags.map(tag => tag.tag))
    if (tags_types.has(undefined)) {
      tags_types.delete(undefined)
    }
    if (tags_types.size === 0) {
      return null
    }
    const series = [
      { id: 1, text: "Noun", children: [] },
      { id: 2, text: "Adjective", children: [] },
      { id: 3, text: "Verb", children: [] },
      { id: 4, text: "Adverb", children: [] },
      { id: 5, text: "Other", children: [] },
    ]

    tags.forEach(tag => {
      const serie_index = series.findIndex(serie => serie.text === tag.tag)
      if (serie_index == -1) {
        return
      }
      const index = series[serie_index].children.findIndex((data) => {
        return data.text === tag.lemma
      })
      if (index != -1) {
        series[serie_index].children[index].countValue += 1
      } else {
        id += 1;
        series[serie_index].children.push({countValue: 1, id: tag.lemma , text: tag.lemma })
      }
    });

    series.map((serie) => {
      serie.children.sort((a,b) => {return b.countValue - a.countValue})
    })



    const all = series.map(serie => serie.children).flat().sort((a,b) => {return b.countValue - a.countValue})
    series.push({id: 0,text: "All", children: all})

    series

    return series
  }
}
